import { render, staticRenderFns } from "./ImagePopin.vue?vue&type=template&id=45ee03b5&scoped=true&lang=pug&"
import script from "./ImagePopin.vue?vue&type=script&lang=js&"
export * from "./ImagePopin.vue?vue&type=script&lang=js&"
import style0 from "./ImagePopin.vue?vue&type=style&index=0&id=45ee03b5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ee03b5",
  null
  
)

export default component.exports